export enum AnalyticsQueryKeys {
  getAllBankAccounts = "get-all-bank-accounts",
  getASingleBankAccount = "get-a-single-bank-account",
  adminGetClientPackages = "admin-get-client-packages",
  adminRecentSales = "admin-recent-sales",
  adminAgeGroup = "admin-age-group",
}
